const signUpSetting = process.env.NEXT_PUBLIC_ENABLE_SIGN_UP?.trim().toLowerCase();

export const isSignUpEnabled = signUpSetting
  ? signUpSetting === "true"
  : process.env.NODE_ENV !== "production";

export const authEntryHref = isSignUpEnabled ? "/sign-up" : "/waitlist";
export const authEntryLabel = isSignUpEnabled ? "Criar conta gratuita" : "Entrar na lista";
export const authEntryShortLabel = isSignUpEnabled ? "Criar" : "Lista";
